import {CanActivateFn} from "@angular/router";
import {inject, Type} from "@angular/core";
import {LocalizedRouter} from "@app/presentation/services/localized-router";
import {routesNames} from "@app/app-routing.module";
import {PlatformService} from "@app/presentation/services/platform.service";

import {
    DesktopModalType,
    MobileModalType,
    ModalConfig,
    ModalService
} from "@app/presentation/services/modal/modal.service";

export const openOnModalGuard: CanActivateFn = (route, state) => {
    const modalService = inject(ModalService);
    const localizedRouter = inject(LocalizedRouter);
    const platformService = inject(PlatformService);

    const homeUrlTree = localizedRouter.createUrlTree(['/', routesNames.home]);

    if (platformService.isServer ) {
        return homeUrlTree;
    }

   const loadComponent = route.routeConfig?.loadComponent as () => Promise<Type<any>>;
    if (loadComponent == null) {
        return homeUrlTree;
    }

    loadComponent().then(component => {
        if (component == null) {
            return;
        }
        const modalConfig: ModalConfig = {
            mobileModalType: MobileModalType.BOTTOM_SHEET,
            desktopModalType: DesktopModalType.SIDE_SHEET,
            data: {
                queryParams: route.queryParams
            },
        }
        modalService.open(component, modalConfig);
    });

    return false;
};